module.exports = __webpack_public_path__ + "static/media/answer.d0cb8743.svg";